import { useEffect } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import ModalContactForm from "components/Forms/Contact/UpgradePropertyContactModal";
import { modalSet } from "_slices/view";
import { checkLoggedIn, getUserDetails } from "context/context";
import { useRouter } from 'next/navigation'
const UpgradeForm = ({id, address, type, name}) => {
  const reduxDispatch = useDispatch();
  const modal = useSelector((state: RootStateOrAny) => state.view.modal);
  const loggedIn = checkLoggedIn()
  const userDetails = getUserDetails();
  const router = useRouter();
  // const [{ contactForm, active }, dispatch] = useResultReducer();
  // const { id, address, type, name } = active;

  let property = {
    type: type,
    id: id,
    name: name,
    address: address,
  };

  const closeModal = () => {
    reduxDispatch(
      modalSet({
        visible: false,
        router
      })
    );
    reduxDispatch({ type: "contactFormReset" });
  };

  useEffect(() => {}, [loggedIn, userDetails]);

  return (
    <ModalContactForm
      user={userDetails}
      type={type}
      property={property}
      id="contactUs"
      form={[]}
      onSubmit={(e) => {
        e.preventDefault();
      } }
      modal={{
        id: "upgradePropertyModal",
        isOpen: modal.type === "upgradeProperty" && modal.visible,
        label: `Send a message`,
        closeModal: closeModal,
        onClick: (e) => {
          e.stopPropagation();
        },
      }}  />
  );
};

export default UpgradeForm;
